<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-11 14:17:21
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-17 11:15:30
 * @Description: 风险提示
 -->

<template>
  <div class="risk-tips-wrapper">
    <iframe
      src="https://jydpro.jinr.com/uploadsFiles/jyd/static/risk.pdf"
      frameborder="0"
      class="pdf-wrapper"
    >
    </iframe>
    <!-- <h2>网络借贷风险和禁止性行为提示书</h2>
    <p class="bold">
      一、网络借贷风险提示：在您通过 鲸鱼平台
      （以下简称鲸鱼）进行资金出借的过程中，也许会面临以下可能导致您出借资金及收益受损的各种风险。请您在进行资金出借前仔细阅读以下内容，了解融资项目信贷风险，确保自身具备相应的投资风险意识、风险认知能力、风险识别能力和风险承受能力，拥有非保本类金融产品投资的经历并熟悉互联网，并请您根据自身的风险承受能力选择是否出借资金及出借资金的数额。
    </p>
    <p>
      1.
      法律及监管风险：因许多法律和法规相对较新且可能发生变化，相关官方解释和执行可能存在较大不确定性等因素引起的风险。有些新制定的法律、法规或修正案的生效可能被延迟；有些新颁布或生效的法律法规可能具有追溯力从而对您的投资利益造成不利影响。
    </p>
    <p>
      2.
      政策风险：因国家宏观政策、财政政策、货币政策、监管导向、行业政策、地区发展政策等因素引起的风险。
    </p>
    <p>3. 市场风险：因市场资金面紧张或利率波动、行业不景气、企业效益下滑等因素引起的风险。</p>
    <p>
      4.
      借款人信用风险：针对平台上的债权，鲸鱼仅在债权形成前对借款人的借款需求及相关信息进行必要审核，但是鲸鱼不对借款人的还款能力做出任何明示或默示的担保或保证，并且如果发生债权转让，鲸鱼不会在债权转让时再次对借款人进行信用审核，您受让的债权可能在其受让前已经存在逾期情况。当借款人因收入情况、财产状况发生变化、人身出现意外、发生疾病、死亡等情况，短期或者长期丧失还款能力，或者借款人的还款意愿发生变化时，您的出借资金可能无法按时回收甚至无法回收，您的预期收益可能无法实现。鲸鱼没有义务对逾期的本息以及费用进行垫付或未经委托对借款人进行追索。
    </p>
    <p>
      5.
      资金流动性风险：针对您的出借本金或者回款再出借资金，鲸鱼会根据网络借贷相关协议约定积极协助您寻找、推荐借款人，以完成资金出借、获取收益之目的，但鲸鱼寻找、推荐借款人的时间存在一定不确定性。同时，鲸鱼将根据网络借贷相关协议约定在您提出需要时，努力帮助您寻找、向您推荐愿意受让债权的第三方，以完成您的债权转让，但鲸鱼不对债权转让的实现以及实现时间做出任何承诺和保证。
    </p>
    <p>
      6.
      技术风险：由于无法控制和不可预测的系统故障、设备故障、通讯故障、电力故障、网络故障、黑客或计算机病毒攻击、以及其它因素，可能导致平台出现非正常运行或者瘫痪，由此导致您无法及时进行查询、充值、出借、提现等操作。
    </p>
    <p>
      7. 不可抗力风险：由于战争、动乱、自然灾害等不可抗力因素的出现而可能导致您出借资金损失的风险。
    </p>
    <p class="bold">
      二、网络借贷禁止性行为提示： 鲸鱼平台
      作为网络借贷信息中介平台，将严格依据《网络借贷信息中介机构业务活动管理暂行办法》的规定，不予从事或者接受委托从事下列活动，请您知悉并共同进行监督：
    </p>
    <p>1. 为自身或变相为自身融资；</p>
    <p>
      2. 直接或间接接受、归集出借人的资金；
    </p>
    <p>3. 直接或变相向出借人提供担保或者承诺保本保息；</p>
    <p>
      4.
      自行或委托、授权第三方在互联网、固定电话、移动电话等电子渠道以外的物理场所进行宣传或推介融资项目
    </p>
    <p>
      5. 发放贷款，但法律法规另有规定的除外；
    </p>
    <p>6. 将融资项目的期限进行拆分；</p>
    <p>
      7. 自行发售理财等金融产品募集资金，代销银行理财、券商资管、基金、保险或信托产品等金融产品；
    </p>
    <p>
      8. 开展类资产证券化业务或实现以打包资产、证券化资产、信托资产、基金份额等形式的债权转让行为；
    </p>
    <p>
      9.
      除法律法规和网络借贷有关监管规定允许外，与其他机构投资、代理销售、经纪等业务进行任何形式的混合、捆绑、代理；
    </p>
    <p>
      10.
      虚构、夸大融资项目的真实性、收益前景，隐瞒融资项目的瑕疵及风险，以歧义性语言或其他欺骗性手段等进行虚假片面宣传或促销等，捏造、散布虚假信息或不完整信息损害他人商业信誉，误导出借人或借款人；
    </p>
    <p>
      11.
      向借款用途为投资股票、场外配资、期货合约、结构化产品及其他衍生品等高风险的融资提供信息中介服务；
    </p>
    <p>
      12. 从事股权众筹等业务；
    </p>
    <p>13. 法律法规、网络借贷有关监管规定禁止的其他活动。</p>
    <p class="bold">三、 借款人不得从事下列行为：</p>
    <p>1. 通过故意变换身份、虚构融资项目、夸大融资项目收益前景等形式的欺诈借款；</p>
    <p>
      2.
      通过多个网络借贷信息中介机构或者通过变换项目名称、对项目内容进行非实质性变更等方式，就同一融资项目进行重复融资；
    </p>
    <p>
      3. 在网络借贷信息中介机构以外的公开场所发布同一融资项目的信息；
    </p>
    <p>4. 已发现网络借贷信息中介机构提供的服务中含有本办法第十条所列内容，仍进行交易；</p>
    <p>5. 法律法规和网络借贷有关监管规定禁止从事的其他活动。</p>
    <p>四、 参与网络借贷的出借人应当履行下列义务：</p>
    <p>1. 向网络借贷信息中介机构提供真实、准确、完整的身份等信息；</p>
    <p>2. 出借资金为来源合法的自有资金 ；</p>
    <p>3. 禁止利用鲸鱼平台从事洗钱、传销等违法活动 ；</p>
    <p>4. 了解融资项目信贷风险，确认具有相应的风险认知和承受能力；</p>
    <p>
      5. 自行承担借贷产生的本息损失；
    </p>
    <p>6. 借贷合同及有关协议约定的其他义务。</p> -->
    <!-- <div v-html="mdHtml" class="center"></div> -->
    <div class="btn" @click="handleClick">返回</div>
  </div>
</template>
<script>
// import showdown from 'showdown';
// import reskTips from './risk-tips.md';
export default {
  name: 'risk-tips',
  // components: {
  //   showdown
  // },
  data() {
    return {
      // md: reskTips,
      mdHtml: ''
    };
  },
  mounted() {
    // let converter = new showdown.Converter();
    // let text = reskTips.toString();
    // this.mdHtml = converter.makeHtml(text);
    // console.log(this.mdHtml);
  },
  methods: {
    handleClick() {
      this.$router.back();
    }
  }
};
</script>
<style lang="less" scoped>
.risk-tips-wrapper {
  padding: 40px;
  background: #ffffff;
  .pdf-wrapper {
    width: 100%;
    height: 800px;
  }
  h2 {
    text-align: center;
    font-size: 26px;
    font-weight: 600;
    line-height: 40px;
  }
  p {
    margin: 10px;
    text-indent: 2em;
  }
  .bold {
    font-weight: 700;
  }
  .btn {
    background: #2c6eff;
    color: #ffffff;
    font-size: 20px;
    width: 200px;
    height: 40px;
    margin: 20px auto 0;
    border-radius: 8px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
}
</style>
